import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFoilingSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 50 50",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			id: "white",
			children: /* @__PURE__ */ _jsx("polygon", {
				className: "icon-white",
				points: "24.95 17.94 12.45 25.04 8.6 22.84 8.66 24.11 10.43 26.18 6.98 28.15 6.98 30.02 25.02 40.44 42.95 30.09 42.95 28.21 24.95 17.94"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "grey",
			children: /* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "m42.64,28.75v1.15l-17.3,9.99v-1.15l4.68-2.7-1.75.29-3.24,1.87L7.6,28.15l3.3-1.9-.62-.36-3.45,1.99s-.04.03-.06.05c0,0,0,0-.01.01-.01.01-.02.03-.03.04,0,0,0,.01-.01.02-.01.02-.02.04-.03.07,0,0,0,0,0,0,0,.02,0,.05,0,.07,0,0,0,0,0,0v1.87c0,.11.06.21.16.27l18.04,10.42s.1.04.16.04.11-.01.16-.04l17.93-10.35c.1-.06.16-.16.16-.27v-1.87s-.62.54-.62.54Zm-17.93,11.14L7.29,29.84v-1.15l17.42,10.06v1.15Z"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "color",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m43.14,27.88l-18.04-10.42c-.12-.07-.26-.07-.38,0l-12.34,7.12-3.56-2.06c-.13-.07-.29-.07-.42,0-.13.07-.21.21-.21.36,0,1.37.44,2.4,1.24,2.92,0,0,.01,0,.02.01l.11.06s.01,0,.02,0c0,0,0,0,0,0l1.44.83c.07.04.14.06.21.06.14,0,.28-.07.36-.21.12-.2.05-.45-.15-.57l-1.44-.83s-.01,0-.02,0c0,0,0,0,0,0l-.1-.06c-.41-.26-.68-.78-.8-1.47l17.15,9.9c.03.74.2,1.36.48,1.86-.06.18.01.39.19.49l.19.11s.1.04.16.05c.07.06.14.12.22.17.06.04.12.05.18.06.29.16.61.24.95.24.47,0,.97-.15,1.48-.44l13.06-7.54c.12-.07.19-.19.19-.33s-.07-.26-.19-.33Zm-13.45,7.54c-.63.36-1.22.43-1.67.2-.03-.03-.06-.06-.1-.09-.54-.35-.86-1.16-.86-2.22,0-.15-.08-.29-.21-.36l-13.72-7.92,11.76-6.79,17.28,9.97-12.49,7.21Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m17.22,29.35l-1.44-.83c-.2-.11-.45-.05-.57.15-.12.2-.05.45.15.57l1.44.83c.07.04.14.06.21.06.14,0,.28-.07.36-.21.12-.2.05-.45-.15-.57Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m14.33,27.68l-1.44-.83c-.2-.12-.45-.05-.57.15-.12.2-.05.45.15.57l1.44.83c.07.04.14.06.21.06.14,0,.28-.07.36-.21.12-.2.05-.45-.15-.57Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m20.11,31.01l-1.44-.83c-.2-.12-.45-.05-.57.15-.12.2-.05.45.15.57l1.44.83c.07.04.14.06.21.06.14,0,.28-.07.36-.21.12-.2.05-.45-.15-.57Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m25.88,34.35l-1.44-.83c-.2-.12-.45-.05-.57.15s-.05.45.15.57l1.44.83c.07.04.14.06.21.06.14,0,.28-.07.36-.21.12-.2.05-.45-.15-.57Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m22.99,32.68l-1.44-.83c-.2-.12-.45-.05-.57.15-.12.2-.05.45.15.57l1.44.83c.07.04.14.06.21.06.14,0,.28-.07.36-.21.12-.2.05-.45-.15-.57Z"
				})
			]
		})
	]
});
export default SvgFoilingSm;
